const BASE_URL = import.meta.env.VITE_BASE_URL_API;
export const CHECK_LOGIN_URL = '/auth/check-login';
export async function request(endpoint, method = "GET", body, headers) {
  const url = `${BASE_URL}${endpoint}`;

  const options = {
    method,
    headers: {
      credentials: 'include',
      'Content-Type': 'application/json',
      ...headers,
    },
  };

  if (body) {
    options.body = JSON.stringify(body);
  }

  try {
    const response = await fetch(url, options);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
        throw error;
  }
}

export async function getConfiguration() {
  return request('/api/configuration');
}

export async function checkAuth() {
  const url = `${BASE_URL}${CHECK_LOGIN_URL}`;
  const options = {
    method: 'GET', redirect: 'manual',
    headers: {
      credentials: 'include',
      "X-CHECK-LOGIN": true
    }
  }
  try {
    const response = await fetch(url, options)
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response;
  }
  catch (error) {
        throw error;
  }
}
